import React, { useMemo, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import makeAnimated from "react-select/animated";
import { regions } from "../../data/country";
// import { colourOptions } from '../data';

import {
    Block,
    Input,
    Button,
    DocumentScan,
    Loading,
    PreviewAltCard,
    PreviewCard,
    Icon,
    // Select,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import RSelect2 from "../../../components/select/ReactSelect2";
import countryList from "react-select-country-list";
import { apiRequest } from "../../../utils/Api";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Alert, Card, Col, Row, Spinner } from "reactstrap";
import { getStep } from "../../../utils/Utils";

const day_options = Array.from({ length: 31 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, '0'),
    label: (i + 1).toString().padStart(2, '0'),
}));

const month_options = Array.from({ length: 12 }, (_, i) => ({
    value: (i + 1).toString().padStart(2, '0'),
    label: (i + 1).toString().padStart(2, '0'),
}));

const year_options = Array.from({ length: 100 }, (_, i) => ({
    value: (2023 + i).toString(),
    label: (2023 + i).toString(),
}));


const transactionTypes = [
    { value: "dep", label: "Deposits" },
    { value: "close", label: "Closing Funds" },
    { value: "ret", label: "Retainers" },
    { value: "settle", label: "Settlement Funds" },
    { value: "invest", label: "Investment Funds" },
    { value: "don", label: "Donations" },
    { value: "comp", label: "Compensation" },
    { value: "gift", label: "Gifts" },
    { value: "rec", label: "Recurring Payments" },
];



const AmlFinancialDiligence = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const [load, setLoad] = useState(0);
    if (load < 1) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setLoad(2);
    }

    useEffect(() => {
        setLoading(false);
    }, []);

    const {
        reset,
        register,
        handleSubmit,
        getValues,
        formState: { errors },
        setValue,
        watch,
    } = useForm();

    const onselect = (name, value) => {
        console.log(name);
        if (name === "country") {
            setValue("region", "");
        }
        // console.log(value);
        // console.log(errors);
        if (name === "involve_money" && value === "n") {
            reset();
        }
    };

    const y_n_options = [
        { value: "y", label: "Yes" },
        { value: "n", label: "No" },
    ];

    const sourceOfFunds = [
        { value: "psa", label: "Personal savings account" },
        { value: "pension", label: "Pension releases" },
        { value: "stocks", label: "Sale of stocks" },
        { value: "dividends", label: "Share dividends" },
        { value: "partnership", label: "Partnership distributions" },
        { value: "property_sale", label: "Sale of personal property such as art or car" },
        { value: "gambling", label: "Gambling winnings" },
        { value: "inheritance", label: "Inheritances or gifts" },
        { value: "compensation", label: "Compensation from legal rulings or settlements" },
        { value: "employment", label: "Income from employment" },
        { value: "rental", label: "Rental Income" },
        { value: "joint_accounts", label: "Joint savings accounts" },
        { value: "investment_profits", label: "Profits from other investments" },
        { value: "business_profit", label: "Profit from legitimate business activities" },
        { value: "real_estate_sale", label: "Proceeds from the sale of real estate" },
        { value: "other", label: "Other" }
    ];

    const purpose_options = [
        { "value": "real_estate", "label": "Purchasing real estate" },
        { "value": "vehicle", "label": "Purchasing a vehicle" },
        { "value": "jewelry", "label": "Purchasing jewelry" },
        { "value": "equipment", "label": "Purchasing equipment for a business" },
        { "value": "medical_expenses", "label": "To pay for medical expenses" },
        { "value": "travel", "label": "To pay for travel" },
        { "value": "legal_fees", "label": "To pay for legal fees" },
        { "value": "legal_matter", "label": "To pay for a judgement or settlement of a legal matter" },
        { "value": "taxes", "label": "To pay for taxes" },
        { "value": "tuition", "label": "To pay tuition, board, lodging" },
        { "value": "room_board", "label": "To pay for room and board" },
        { "value": "home_rent", "label": "To pay rent for your home" },
        { "value": "business_rent", "label": "To pay rent for your business" },
        { "value": "living_expenses", "label": "Living expenses" },
        { "value": "gift", "label": "To give as a gift" },
        { "value": "leasehold_improvements", "label": "Leasehold improvements" },
        { "value": "home_renovation", "label": "Renovating your home" },
        { "value": "business_loans", "label": "To pay down business loans" },
        { "value": "business_credit_cards", "label": "To pay down business credit cards" },
        { "value": "personal_loans", "label": "To pay down personal loans" },
        { "value": "personal_credit_cards", "label": "To pay down personal credit cards" },
        { "value": "mortgages", "label": "To pay down mortgages on your home" },
        { "value": "property_renovation", "label": "Renovating a property other than your home" },
        { "value": "working_capital", "label": "Working capital for an existing business" },
        { "value": "startup_capital", "label": "Startup capital for a new business" },
        { "value": "real_estate_fund", "label": "Investing in a real estate fund" },
        { "value": "mortgage_fund", "label": "Investing in a mortgage fund" },
        { "value": "mutual_fund", "label": "Investing in a mutual fund" },
        { "value": "income_fund", "label": "Investing in an income fund" },
        { "value": "investment_fund", "label": "Investing in an investment fund" },
        { "value": "private_business", "label": "Investing in a private business" },
        { "value": "public_securities", "label": "Investing in public securities" },
        { "value": "private_placement", "label": "Investing in a private placement" },
        { "value": "other", "label": "Other" }
    ]

    const perOptions = [
        { value: "hour", label: "Hourly" },
        { value: "day", label: "Daily" },
        { value: "month", label: "Monthly" },
        { value: "week", label: "Weekly" },
        { value: "bi-week", label: "Bi-weekly" },
        { value: "bi-monthly", label: "Bi-monthly" },
        { value: "quarter", label: "Quarterly" },
        { value: "semi-ann", label: "Semi-annually" },
        { value: "ann", label: "Annually" },
    ];

    const transactionNum = [
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 6, label: 6 },
        { value: 7, label: 7 },
        { value: 8, label: 8 },
        { value: 9, label: 9 },
    ];



    const locationAccess = async () => {
        return new Promise((resolve, reject) => {
            const options = {
                enableHighAccuracy: true, // Request high accuracy (GPS)
                timeout: 10000, // Set a timeout of 10 seconds
                maximumAge: 0, // Ensure the result is not a cached position
            };

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    // setValue("location", { latitude, longitude });
                    resolve({ latitude, longitude });
                },
                (err) => {
                    // Handle error
                    console.log(err);
                    resolve({ latitude: null, longitude: null });
                },
                options,
            );
        });
    };

    const onFormSubmit = async () => {
        console.log("submit");
        console.log(getValues())
        // return
        setSubmitButtonLoading(true);
        const location = await locationAccess();
        setValue("latitude", location.latitude);
        setValue("longitude", location.longitude);

        let data = {
            involve_money: getValues("involve_money"),
            latitude: location.latitude,
            longitude: location.longitude
        }
        console.log(data)

        const tempData = getValues()
        console.log(getValues())

        if (getValues("involve_money") === "y") {
            data.transaction_number = tempData.transaction_number
            data.financial_institution = tempData.financial_institution
            data.branch_address = tempData.branch_address
            data.institution_number = tempData.institution_number
            data.transit_number = tempData.transit_number
            data.account_number = tempData.account_number
            data.account_name = tempData.account_name
            data.account_address = tempData.account_address
            data.routing_number = tempData.routing_number
            data.iban = tempData.iban
            data.swift_bic = tempData.swift_bic
            let transactions = [];
            for (let i = 0; i < getValues('transaction_number'); i++) {
                let trandaction_detail = {}
                trandaction_detail = {
                    nickname: tempData[`transaction_nickname_${i}`],
                    type: tempData[`transaction_type_${i}`],
                    day_pay: tempData[`day_pay_${i}`],
                    month_pay: tempData[`month_pay_${i}`],
                    year_pay: tempData[`year_pay_${i}`],
                    purpose_of_funds: tempData[`purpose_of_funds_${i}`],
                    source_of_funds: tempData[`source_of_funds_${i}`],
                    financial_institution: tempData[`financial_institution_${i}`],
                    currency: tempData[`currency_${i}`],
                    estimated_amount: tempData[`estimated_amount_${i}`],
                    is_payor: tempData[`is_payor_${i}`],

                }

                if (tempData[`transaction_type_${i}`] === 'ret') {
                    trandaction_detail.ret_block_fee = tempData[`ret_block_fee_${i}`]
                    trandaction_detail.ret_contingency = tempData[`ret_contingency_${i}`]
                    trandaction_detail.ret_dibursements = tempData[`ret_dibursements_${i}`]
                    trandaction_detail.ret_notes = tempData[`ret_notes_${i}`]
                    trandaction_detail.ret_rate = tempData[`ret_rate_${i}`]
                    trandaction_detail.ret_rate_per = tempData[`ret_rate_per_${i}`]
                    trandaction_detail.ret_fixed_fee = tempData[`ret_fixed_fee_${i}`]
                }

                if (tempData[`is_payor_${i}`] === 'n') {
                    trandaction_detail.payor_name = tempData[`payor_name_${i}`]
                    trandaction_detail.payor_address = tempData[`payor_address_${i}`]
                    trandaction_detail.payor_phone = tempData[`payor_phone_${i}`]
                    trandaction_detail.payor_email = tempData[`payor_email_${i}`]
                    trandaction_detail.payor_occupation = tempData[`payor_occupation_${i}`]
                }
                transactions.push(trandaction_detail);
            }

            data.transactions = transactions
        }



        console.log(data)
        // setSubmitButtonLoading(false);
        // return


        try {
            await apiRequest(`/ccr/kyc/step/${await getStep('financial_diligence')}`, "POST", data).then((resp) => {
                if (resp) {

                    if (resp.code === 200) {
                        console.log(resp);
                        console.log(localStorage.getItem("at_requestor"));
                        localStorage.setItem("at_position", JSON.stringify({ step: resp.data.step }));
                        props.jump(resp.data.step);
                    } else {
                        toast.error("Something went wrong,Try again later", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        setSubmitButtonLoading(false);
                        console.log("error response: ", resp.message);
                    }
                } else {
                    setSubmitButtonLoading(false);
                }
            });
        } catch (err) {
            toast.error("Something went wrong,Try again later", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }

    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        // console.log('submit');
        console.log(getValues())
        await handleSubmit(onFormSubmit)();

        if (Object.keys(errors).length) {
            toast.error('missing information', {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }
    };

    return (
        <React.Fragment>
            <Head title="Transaction Diligence" />
            {/* <HeaderCCR></HeaderCCR> */}
            <div className="mb-2"></div>
            {loading && <Loading />}
            {!loading && (
                <Content>
                    <div className="content-page wide-md m-auto">
                        <Block className={submitButtonLoading && "disabled"}>
                            <h5>Transaction Diligence</h5>
                            <p>Please make sure all the information you have provided is correct and true.</p>

                            <form className="content clearfix" onSubmit={handleFormSubmit}>
                                <div className="entry">
                                    <RSelect2
                                        onselect={onselect}
                                        setValue={setValue}
                                        label="Does your Matter involve money? "
                                        sub="(*Deposits, retainers, buying, selling, lending, investing, paying-out, redeeming, transfering, gifting, etc.)"
                                        register={register}
                                        requiredMessage="This field is required"
                                        id="involve_money"
                                        name="involve_money"
                                        errors={errors}
                                        options={y_n_options}
                                        placeholder="Select"
                                        className="form-control-lg p-0 border-0 form-control"
                                    />
                                </div>
                                {watch("involve_money") === "y" && (
                                    <>

                                        <div className="entry">
                                            <RSelect2
                                                onselect={onselect}
                                                setValue={setValue}
                                                // selectedAct={watch("is_businvolve_moneyiness")}
                                                label="How many transactions will you be paying for?"
                                                sub='*e.g. You are buying in two or more closings in the same Matter'
                                                // sub="(*Deposits, retainers, buying, selling, lending, investing, paying-out, redeeming, transfering, gifting, etc.)"
                                                register={register}
                                                requiredMessage="This field is required"
                                                id="transaction_number"
                                                name="transaction_number"
                                                errors={errors}
                                                options={transactionNum}
                                                placeholder="Select"
                                                className="form-control-lg p-0 border-0 form-control"
                                            />
                                        </div>
                                        {watch('transaction_number') && Array.from({ length: watch('transaction_number') }, (_, index) => (
                                            <>
                                                <div key={index}>
                                                    <PreviewAltCard className="mb-2">
                                                        <div>
                                                            <h6 className="my-3">
                                                                Transaction {index + 1} of {watch('transaction_number')}
                                                            </h6>
                                                        </div>
                                                        <Row>
                                                            <div className="form-control-wrap mb-2">
                                                                <Input
                                                                    type="text"
                                                                    label="Transaction Nickname:"
                                                                    id={`transaction_nickname_${index}`}
                                                                    name={`transaction_nickname_${index}`}
                                                                    className="form-control-lg form-control"

                                                                    required
                                                                    requiredMessage={{
                                                                        required: "This field is required",
                                                                        pattern: {
                                                                            value: /^.{1,80}$/,
                                                                            message: "Max 80 characters",
                                                                        },
                                                                    }}
                                                                    errors={errors}
                                                                    register={register}
                                                                />
                                                            </div>
                                                        </Row>
                                                        <Row>
                                                            <div className="form-control-wrap mb-2">
                                                                <RSelect2
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    register={register}
                                                                    requiredMessage="This field is required"
                                                                    errors={errors}
                                                                    options={transactionTypes}
                                                                    placeholder="Select"
                                                                    label="Type of transaction funds:"
                                                                    id={`transaction_type_${index}`}
                                                                    name={`transaction_type_${index}`}
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                />
                                                            </div>
                                                        </Row>
                                                        {watch(`transaction_type_${index}`) === 'ret' &&
                                                            <PreviewCard className='mb-1'>

                                                                <Row >

                                                                    <Col>
                                                                        <div className="form-control-wrap mb-2">
                                                                            <Input
                                                                                type="text"
                                                                                label="Rate ($):"
                                                                                id={`ret_rate_${index}`}
                                                                                name={`ret_rate_${index}`}
                                                                                className="form-control-lg form-control"
                                                                                required
                                                                                requiredMessage={{
                                                                                    required: "This field is required",
                                                                                    pattern: {
                                                                                        value: /^.{1,80}$/,
                                                                                        message: "Max 80 characters",
                                                                                    },
                                                                                }}
                                                                                errors={errors}
                                                                                register={register}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="form-control-wrap mb-2">
                                                                            <RSelect2
                                                                                onselect={onselect}
                                                                                setValue={setValue}
                                                                                // selectedAct={watch("is_businvolve_moneyiness")}
                                                                                label="Per:"
                                                                                // sub="(*Deposits, retainers, buying, selling, lending, investing, paying-out, redeeming, transfering, gifting, etc.)"
                                                                                register={register}
                                                                                requiredMessage="This field is required"
                                                                                id={`ret_rate_per_${index}`}
                                                                                name={`ret_rate_per_${index}`}
                                                                                errors={errors}
                                                                                options={perOptions}
                                                                                placeholder="Select"
                                                                                className="form-control-lg p-0 border-0 form-control"
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Block Fee ($):"
                                                                            id={`ret_block_fee_${index}`}
                                                                            name={`ret_block_fee_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Fixed Fee ($):"
                                                                            id={`ret_fixed_fee_${index}`}
                                                                            name={`ret_fixed_fee_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Contingency (%):"
                                                                            id={`ret_contingency_${index}`}
                                                                            name={`ret_contingency_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Dibursements ($):"
                                                                            id={`ret_dibursements_${index}`}
                                                                            name={`ret_dibursements_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="textarea"
                                                                            label="Notes:"
                                                                            id={`ret_notes_${index}`}
                                                                            name={`ret_notes_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                            </PreviewCard>
                                                        }
                                                        <Row>
                                                            <div className="form-label-group">
                                                                <label className="form-label" htmlFor="default-01">
                                                                    Date paid or required:
                                                                    <span className="text-danger">*</span>
                                                                </label>
                                                            </div>
                                                            <Col className="mt-1 mb-1 col-sm-4 col-4 col-md-4">
                                                                <RSelect2
                                                                    onNameChange={watch(`day_pay_${index}`)}
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedTitle={watch("title")}
                                                                    // label="date of birth"
                                                                    requiredMessage="This field is required"
                                                                    errors={errors}
                                                                    register={register}
                                                                    options={day_options}
                                                                    name={`day_pay_${index}`}
                                                                    color="#f5f5f5"
                                                                    id={`day_pay_${index}`}
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                    placeholder='day'
                                                                />
                                                            </Col>
                                                            <Col className="mt-1 mb-1 col-sm-4 col-4 col-md-4">
                                                                <RSelect2
                                                                    onNameChange={watch(`month_pay_${index}`)}
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedTitle={watch("title")}
                                                                    // label="date of birth"
                                                                    requiredMessage="This field is required"
                                                                    errors={errors}
                                                                    register={register}
                                                                    options={month_options}
                                                                    name={`month_pay_${index}`}
                                                                    color="#f5f5f5"
                                                                    id={`month_pay_${index}`}
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                    placeholder={`month`}
                                                                />
                                                            </Col>
                                                            <Col className="mt-1 mb-1 col-sm-4 col-4 col-md-4">
                                                                <RSelect2
                                                                    onNameChange={watch(`year_pay_${index}`)}
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedTitle={watch("title")}
                                                                    // label="date of birth"
                                                                    requiredMessage="This field is required"
                                                                    errors={errors}
                                                                    register={register}
                                                                    options={year_options}
                                                                    name={`year_pay_${index}`}
                                                                    color="#f5f5f5"
                                                                    id={`year_pay_${index}`}
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                    placeholder='Year'
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <div className="entry">
                                                                <RSelect2
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedAct={watch("is_businvolve_moneyiness")}
                                                                    label="Purpose of funds: "

                                                                    register={register}
                                                                    requiredMessage="This field is required"
                                                                    id={`purpose_of_funds_${index}`}
                                                                    name={`purpose_of_funds_${index}`}
                                                                    errors={errors}
                                                                    options={purpose_options}
                                                                    placeholder="Select"
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                />
                                                            </div>
                                                        </Row>
                                                        <Row>
                                                            <div className="entry">
                                                                <RSelect2
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedAct={watch("is_businvolve_moneyiness")}
                                                                    label="Source of funds: "
                                                                    register={register}
                                                                    requiredMessage="This field is required"
                                                                    id={`source_of_funds_${index}`}
                                                                    name={`source_of_funds_${index}`}
                                                                    errors={errors}
                                                                    options={sourceOfFunds}
                                                                    placeholder="Select"
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                />
                                                            </div>
                                                        </Row>

                                                        <Row>
                                                            <div className="form-control-wrap mb-2">
                                                                <Input
                                                                    type="text"
                                                                    label="Financial institution:"
                                                                    id={`financial_institution_${index}`}
                                                                    name={`financial_institution_${index}`}
                                                                    className="form-control-lg form-control"
                                                                    required
                                                                    requiredMessage={{
                                                                        required: "This field is required",
                                                                        pattern: {
                                                                            value: /^.{1,80}$/,
                                                                            message: "Max 80 characters",
                                                                        },
                                                                    }}
                                                                    errors={errors}
                                                                    register={register}
                                                                />
                                                            </div>
                                                        </Row>
                                                        <Row>
                                                            <div className="entry">
                                                                <RSelect2
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedAct={watch("is_businvolve_moneyiness")}
                                                                    label="Currency:"
                                                                    // sub="(*Deposits, retainers, buying, selling, lending, investing, paying-out, redeeming, transfering, gifting, etc.)"
                                                                    register={register}
                                                                    requiredMessage="This field is required"
                                                                    id={`currency_${index}`}
                                                                    name={`currency_${index}`}
                                                                    errors={errors}
                                                                    options={[{ value: 'CAD', label: 'CAD' }]}
                                                                    placeholder="Select"
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                />
                                                            </div>
                                                        </Row>
                                                        <Row>
                                                            <div className="form-control-wrap mb-2">
                                                                <Input
                                                                    type="text"
                                                                    label="Estimated amount::"
                                                                    id={`estimated_amount_${index}`}
                                                                    name={`estimated_amount_${index}`}
                                                                    className="form-control-lg form-control"
                                                                    required
                                                                    requiredMessage={{
                                                                        required: "This field is required",
                                                                        pattern: {
                                                                            value: /^.{1,80}$/,
                                                                            message: "Max 80 characters",
                                                                        },
                                                                    }}
                                                                    errors={errors}
                                                                    register={register}
                                                                />
                                                            </div>
                                                        </Row>

                                                        <Row>
                                                            <div className="entry">
                                                                <RSelect2
                                                                    onselect={onselect}
                                                                    setValue={setValue}
                                                                    // selectedAct={watch("is_businvolve_moneyiness")}
                                                                    label="Are you the payor?:"
                                                                    // sub="(*Deposits, retainers, buying, selling, lending, investing, paying-out, redeeming, transfering, gifting, etc.)"
                                                                    register={register}
                                                                    requiredMessage="This field is required"
                                                                    id={`is_payor_${index}`}
                                                                    name={`is_payor_${index}`}
                                                                    errors={errors}
                                                                    options={y_n_options}
                                                                    placeholder="Select"
                                                                    className="form-control-lg p-0 border-0 form-control"
                                                                />
                                                            </div>
                                                        </Row>
                                                        {watch(`is_payor_${index}`) === 'n' &&
                                                            <>

                                                                <Row className="my-2">

                                                                    <h6>Who is the payor?</h6>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Name:"
                                                                            id={`payor_name_${index}`}
                                                                            name={`payor_name_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Address:"
                                                                            id={`payor_address_${index}`}
                                                                            name={`payor_address_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Tel:"
                                                                            id={`payor_phone_${index}`}
                                                                            name={`payor_phone_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Email:"
                                                                            id={`payor_email_${index}`}
                                                                            name={`payor_email_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>
                                                                <Row>
                                                                    <div className="form-control-wrap mb-2">
                                                                        <Input
                                                                            type="text"
                                                                            label="Occupation:"
                                                                            id={`payor_occupation_${index}`}
                                                                            name={`payor_occupation_${index}`}
                                                                            className="form-control-lg form-control"
                                                                            required
                                                                            requiredMessage={{
                                                                                required: "This field is required",
                                                                                pattern: {
                                                                                    value: /^.{1,80}$/,
                                                                                    message: "Max 80 characters",
                                                                                },
                                                                            }}
                                                                            errors={errors}
                                                                            register={register}
                                                                        />
                                                                    </div>
                                                                </Row>


                                                            </>
                                                        }
                                                    </PreviewAltCard>
                                                </div>
                                            </>
                                        ))}


                                        <>
                                            <Row className="my-2">
                                                <p>To avoid bank fraud, such as wire interceptions, if you will be providing banking information for this Matter, please complete the following.* </p>
                                                <span className="form-note">*This information will not be shared in any report, and will only be released through Athenty's portal to the Requestor upon your conset through the Atheny mobile app.</span>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Financial institution:"
                                                        id={`financial_institution`}
                                                        name={`financial_institution`}
                                                        className="form-control-lg form-control"
                                                        required
                                                        requiredMessage={{
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^.{1,80}$/,
                                                                message: "Max 80 characters",
                                                            },
                                                        }}
                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Branch address:"
                                                        id={`branch_address`}
                                                        name={`branch_address`}
                                                        className="form-control-lg form-control"
                                                        required
                                                        requiredMessage={{
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^.{1,80}$/,
                                                                message: "Max 80 characters",
                                                            },
                                                        }}
                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Institution number:"
                                                        id={`institution_number`}
                                                        name={`institution_number`}
                                                        className="form-control-lg form-control"
                                                        required
                                                        requiredMessage={{
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^.{1,80}$/,
                                                                message: "Max 80 characters",
                                                            },
                                                        }}
                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Transit number:"
                                                        id={`transit_number`}
                                                        name={`transit_number`}
                                                        className="form-control-lg form-control"


                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Account number:"
                                                        id={`account_number`}
                                                        name={`account_number`}
                                                        className="form-control-lg form-control"
                                                        required
                                                        requiredMessage={{
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^.{1,80}$/,
                                                                message: "Max 80 characters",
                                                            },
                                                        }}
                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Exact name on account:"
                                                        id={`account_name`}
                                                        name={`account_name`}
                                                        className="form-control-lg form-control"
                                                        required
                                                        requiredMessage={{
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^.{1,80}$/,
                                                                message: "Max 80 characters",
                                                            },
                                                        }}
                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Address associated with the account:"
                                                        id={`account_address`}
                                                        name={`account_address`}
                                                        className="form-control-lg form-control"
                                                        required
                                                        requiredMessage={{
                                                            required: "This field is required",
                                                            pattern: {
                                                                value: /^.{1,80}$/,
                                                                message: "Max 80 characters",
                                                            },
                                                        }}
                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="Routing number"
                                                        id={`routing_number`}
                                                        name={`routing_number`}
                                                        className="form-control-lg form-control"
                                                        required

                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="IBAN (for international):"
                                                        id={`iban`}
                                                        name={`iban`}
                                                        className="form-control-lg form-control"
                                                        required

                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="form-control-wrap mb-2">
                                                    <Input
                                                        type="text"
                                                        label="SWIFT/BIC (for international)"
                                                        id={`swift_bic`}
                                                        name={`swift_bic`}
                                                        className="form-control-lg form-control"
                                                        required

                                                        errors={errors}
                                                        register={register}
                                                    />
                                                </div>
                                            </Row>
                                            <Alert className="alert-icon border" color="white">
                                                <Icon name="alert-circle" />
                                                <div className="mb-1">
                                                    Not all branches have a transit but they will then have a routing number, please make sure at least one of the two is provided.
                                                </div>
                                            </Alert>


                                        </>


                                    </>

                                )}




                                <div className="mt-3 nk-kycfm-note mb-5">
                                    <em className=" icon ni ni-info-fill"></em>
                                    <p>You cannot edit your details once submitted.</p>
                                </div>
                                {/* <div className="actions clearfix">
                    <ul>
                      <li>
                        <button type="submit" style={{float:'right'}} className="btn btn-primary">Next</button>
                      </li>
                    </ul>
                  </div> */}

                                <div className="bg-primary" style={{ position: "fixed", bottom: "0px" }}>
                                    <div className="bg-white col-12" style={{ position: "fixed", bottom: "0px", right: "0px" }}>
                                        <div style={{ margin: "10px 5px 10px 0px", float: "right" }} className="p-1">
                                            {" "}
                                            <Button color="primary" size="" className={submitButtonLoading && "disabled"} outline="">
                                                {submitButtonLoading && <Spinner size="sm" />} Continue
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Block>
                    </div>
                    {/* <ToastContainer /> */}
                </Content>
            )}
        </React.Fragment>
    );
};

export default AmlFinancialDiligence;
